import Vue from "vue";
import iView from "iview";
import locale from "iview/dist/locale/en-US";
import "iview/dist/styles/iview.css";

Vue.use(iView, {locale});

